export const LESSEE_LOSS = {
    title: '中国大地财产保险股份有限公司',
    subtitle: '家庭财产保险<br>附加承租人租房押金损失保险条款',
    register_number: '（注册号：C00001032122018073010852）',
    protocols: [
        {
            intro: '保险责任',
            list: [
                {
                    order: '第一条',
                    context: '在保险期间内，由于发生主险约定的保险事故，造成被保险人无法在其承租的，位于主险保险单载明地址的房屋（以下简称“被保险房屋”）内继续居住，致使被保险人被迫在房屋租赁合同约定的租期终止之日之前办理退租，因此发生的被保险人根据房屋租赁合同的约定无法全部或部分退回的租房押金的损失，保险人按照本附加险合同的约定负责赔偿。'
                }
            ]
        },
        {
            intro: '责任免除',
            list: [
                {
                    order: '第二条',
                    context: '下列任何原因造成的损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人私自改动房屋设计；' },
                        { text: '（二）被保险房屋内或邻居家或公共区域的自来水管道、暖气管道（含暖气片）、下水管道以及太阳能热水器室内外管道破裂导致房屋不适宜居住。'}
                    ]
                },
                {
                    order: '第四条',
                    context: '下列损失、费用，保险人不负责赔偿：',
                    details: [
                        { text: '（一）被保险人的房租、水费、电费、燃气费、通讯费、物业费等各项费用；' },
                        { text: '（二）被保险人因自身行为造成被保险房屋及其附属设备或室内财产（含装潢）的损失的赔偿金；'},
                        { text: '（三）以租房押金扣抵税费或债务的部分；' },
                        { text: '（四）保险单载明的免赔额或按照保险单载明的免赔率计算的免赔额；' },
                        { text: '（五）其他不属于本保险责任范围内的损失、费用。' } 
                    ]
                }
            ]
        },
        {
            intro: '责任限额与免赔额（率）',
            list: [
                {
                    order: '第四条',
                    context: '赔偿限额由投保人与保险人双方协商确定，并在保险单中载明。'
                },
                {
                    order: '第五条',
                    context: '每次事故免赔额（率）由投保人与保险人在签订本附加险合同时协商确定，并在保险单中载明。'
                }
            ]
        },
        {
            intro: '赔偿处理',
            list: [
                {
                    order: '第六条',
                    context: '发生保险责任范围内的损失时，保险人按照被保险人实际遭受的租房押金损失，在扣除每次事故免赔额或按照保险单载明的每次事故免赔率计算的免赔额后进行赔偿，最高不超过赔偿限额或被保险人根据房屋租赁合同已实际支付的租房押金金额，两者以低者为准。'
                }
            ]
        },
        {
            intro: '其他事项',
            list: [
                { order: '第七条', context: '本附加险条款未尽事宜，以主险条款的约定为准；本附加险条款与主险条款若有相抵触之处，以本附加险条款的约定为准。' }
            ]
        }
    ]
}